import { render, staticRenderFns } from "./remainCount.vue?vue&type=template&id=13371ed2&scoped=true"
import script from "./remainCount.vue?vue&type=script&lang=js"
export * from "./remainCount.vue?vue&type=script&lang=js"
import style0 from "./remainCount.vue?vue&type=style&index=0&id=13371ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13371ed2",
  null
  
)

export default component.exports